import { render, staticRenderFns } from "./violation.vue?vue&type=template&id=55005dfa&scoped=true&"
import script from "./violation.vue?vue&type=script&lang=js&"
export * from "./violation.vue?vue&type=script&lang=js&"
import style0 from "./violation.vue?vue&type=style&index=0&id=55005dfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55005dfa",
  null
  
)

export default component.exports